import { EventDateStatusCombinedProps } from './types';

const usePresenter = (props: EventDateStatusCombinedProps): EventDateStatusCombinedProps => {
  return props;
};

export default usePresenter;
